import { Web3Auth, IProvider } from '@web3auth/modal';
import EthereumRpc from './evm.web3';
import EtherContractCall from './eth-call';
import { Alchemy } from 'alchemy-sdk';
import AlchemyApi from '../alchemy';
import { LOCAL_SESSION } from '../common/name-space';

type ResUseWeb3UserInfo = {
  aggregateVerifier: string;
  appState: string;
  dappShare: string;
  email: string;
  idToken: string;
  isMfaEnabled: boolean;
  name: string;
  oAuthAccessToken: string;
  oAuthIdToken: string;
  profileImage: string;
  typeOfLogin: string;
  verifier: string;
  verifierId: string;
};

export default class Web3AuthCall {
  private web3auth: Web3Auth;
  private provider!: IProvider | null;
  private rpc!: EthereumRpc;
  private contractCall!: EtherContractCall;
  private alchemy: AlchemyApi;
  private isInitialized: boolean = false;

  constructor(web3: Web3Auth, provider: IProvider) {
    this.web3auth = web3;
    this.provider = provider;
    this.alchemy = new AlchemyApi(); // constructor에서 초기화
    // constructor에서는 비동기 초기화를 하지 않음
  }

  // 비동기 초기화 메서드
  async initialize(): Promise<void> {
    try {
      // EthereumRpc의 정적 팩토리 메서드 사용
      this.rpc = await EthereumRpc.create(this.provider!);
      this.contractCall = new EtherContractCall(this.rpc);
      this.isInitialized = true;
    } catch (error) {
      console.error('Web3AuthCall 초기화 중 오류 발생:', error);
      this.isInitialized = false;
    }
  }

  // 정적 팩토리 메서드
  static async create(web3: Web3Auth, provider: IProvider): Promise<Web3AuthCall> {
    const instance = new Web3AuthCall(web3, provider);
    await instance.initialize();
    return instance;
  }

  // 초기화 상태 확인
  isReady(): boolean {
    return this.isInitialized;
  }

  connected(): boolean {
    return this.web3auth.connected;
  }

  async getAddress(): Promise<string> {
    if (!this.isInitialized) {
      throw new Error('Web3AuthCall이 초기화되지 않았습니다. initialize()를 먼저 호출하세요.');
    }
    const addr = await this.rpc.getAddress0();
    // const addresses: string[] = await this.rpc.getAccounts()!;
    return addr; // addresses[0];
  }

  getWeb3auth() {
    return this.web3auth;
  }

  getProvider() {
    return this.provider;
  }

  getRpc() {
    if (!this.isInitialized) {
      throw new Error('Web3AuthCall이 초기화되지 않았습니다. initialize()를 먼저 호출하세요.');
    }
    return this.rpc;
  }

  getAlchemy() {
    return this.alchemy;
  }

  getContractCall() {
    if (!this.isInitialized) {
      throw new Error('Web3AuthCall이 초기화되지 않았습니다. initialize()를 먼저 호출하세요.');
    }
    return this.contractCall;
  }

  async getUserInfo() {
    const re = await this.web3auth.getUserInfo();
    return re;
  }

  async logout() {
    await this.web3auth.logout();
    this.setProvider(null);
    localStorage.removeItem(LOCAL_SESSION);
    window.location.reload();
  }

  setProvider(_provider: IProvider | null) {
    this.provider = _provider;
  }
}
